const ENVIRONMENT = getEnvironment();

let API_URL = "https://api.querco.co";

if (ENVIRONMENT === "development") {
  API_URL = import.meta.env.VITE_DEV_API_URL || "http://localhost:8080";
}

const POSTHOG_API_KEY = "phc_oaQTfwuZHnUJDOiltWRtF1FIFOEF34vO74rsBSv0BgB";
const SENTRY_DSN = "https://7bc525b57bda24883ff27e72c9665b22@o4510783176966144.ingest.de.sentry.io/4510783202852944";

function getEnvironment() {
  if (window.location.href.indexOf("localhost") !== -1 || window.location.href.indexOf("127.0.0.1") !== -1 || window.location.port === "8083") {
    return "development";
  }
  return "production";
}

export { API_URL, ENVIRONMENT, POSTHOG_API_KEY, SENTRY_DSN };
